import React, { useEffect, useState } from 'react'

import { TextInput, useFocus } from '../../../../module'
import { type InputRule } from './validationService'

type TypeProps = {
  validationRules: InputRule
  initialValue: Array<string>
  callbackValue: (value: Array<string>) => void
  isInvalid?: boolean
  errorText: string
  /** Checking to see if the TextInput is visible */
  isVisible: boolean
  header: string
}

const EditCellArray = ({
  validationRules,
  initialValue,
  callbackValue,
  isInvalid,
  errorText,
  isVisible,
  header,
}: TypeProps) => {
  const [value, setValue] = useState<string>('')

  useEffect(() => {
    setValue(initialValue?.join(' '))
  }, [initialValue])

  useEffect(() => {
    const oldValue: Array<string> = value?.split(',')
    callbackValue(oldValue)
  }, [callbackValue, value])

  // Focusing the input field on open
  const inputRef = useFocus(isVisible)

  return (
    <TextInput
      hasError={isInvalid}
      errorText={errorText}
      labelText={header}
      type='textarea'
      value={value}
      required={validationRules?.required}
      callout={(_, value) => {
        setValue(value.toString())
      }}
      ref={inputRef}
    />
  )
}

export default EditCellArray
